import React, {PropsWithChildren, useContext } from 'react';
import {LOGIN_ROUTE} from '../../util/constants';
import {AppContext} from '../context/appContext';
import { Navigate } from 'react-router';

export default function AuthRoute({children}: PropsWithChildren<{}>) {
    const {user} = useContext(AppContext);
    if(!user) return <Navigate to={LOGIN_ROUTE}/>
    return children;
}

AuthRoute.displayName = 'AuthRoute';